export default __webpack_public_path__ + "static/media/047-chocolate box.53f24e23.svg";